// extracted by mini-css-extract-plugin
export var animationContainer = "_f2-0";
export var asteriskIcon = "_f2-8";
export var conversationLeftSection = "_f2-4";
export var conversationListItem = "_f2-3";
export var conversationMiddleSection = "_f2-5";
export var conversationRightSection = "_f2-6";
export var detailsContent = "_f2-1";
export var listContainer = "_f2-7";
export var modalContent = "_f2-2";